<template>
  <backbar-page-layout
    v-if="canPerform('authcore.roles.get')"
    hide-profile
    :loading="loading"
    title="role_details.title"
    back-title="role_details.text.back_title"
  >
    <loading-spinner v-if="isLoadingStatus" />
    <b-container v-else>
      <b-row>
        <b-col>
          <i18n path="role_details.text.permissions" tag="h4" class="my-3">
            <span place="role">{{ selectedRole.name }}</span>
          </i18n>
        </b-col>
      </b-row>
      <b-table class="theme-general" :items="permissionAssignments" />
    </b-container>
  </backbar-page-layout>
  <b-alert v-else variant="danger" show>
    <i18n path="status.error.not_authorized" tag="div">
      <span place="page">{{ $t('general.role') }}</span>
    </i18n>
  </b-alert>
</template>

<script>
import { mapState } from 'vuex'
import store from '@/store'

import BackbarPageLayout from '@/components/BackbarPageLayout.vue'
import LoadingSpinner from '@/components/LoadingSpinner.vue'

export default {
  name: 'RoleDetails',
  components: {
    BackbarPageLayout,
    LoadingSpinner
  },

  computed: {
    ...mapState('client', [
      'authenticated'
    ]),
    ...mapState('management/rolesList', [
      'roles'
    ]),
    ...mapState('management/permissionAssignmentsList', [
      'permissionAssignments',
      'loading',
      'errors'
    ]),
    isLoadingStatus () {
      return !this.authenticated || this.loading
    },
    selectedRole () {
      const { roles, id } = this
      const role = roles.find(role => role.id === id)
      if (role === undefined) return {}
      return role
    }
  },

  watch: {
    async authenticated (newVal) {
      if (newVal) {
        // Clear the error message from unauthenticated state
        store.commit('management/rolesList/CLEAR_STATES')
        await store.dispatch('management/rolesList/list')
        await store.dispatch('management/permissionAssignmentsList/list', this.id)
      }
    }
  },

  mounted () {
    store.dispatch('management/rolesList/list') // TODO: Get the role directly given role id, instead of getting the roles list
    store.dispatch('management/permissionAssignmentsList/list', this.id)
  },
  props: {
    id: {
      type: Number,
      required: true
    }
  }
}
</script>
